// source: trip_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var page_pb = require('./page_pb.js');
goog.object.extend(proto, page_pb);
goog.exportSymbol('proto.api.GetTripCoordinateDataRequest', null, global);
goog.exportSymbol('proto.api.GetTripCoordinateDataResponse', null, global);
goog.exportSymbol('proto.api.GetTripCoordinateDataResponse.TripCoordinateItem', null, global);
goog.exportSymbol('proto.api.GetVehiclesTripsRequest', null, global);
goog.exportSymbol('proto.api.GetVehiclesTripsResponse', null, global);
goog.exportSymbol('proto.api.GetVehiclesTripsResponse.VehicleTripItem', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetTripCoordinateDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.GetTripCoordinateDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetTripCoordinateDataRequest.displayName = 'proto.api.GetTripCoordinateDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetTripCoordinateDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.GetTripCoordinateDataResponse.repeatedFields_, null);
};
goog.inherits(proto.api.GetTripCoordinateDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetTripCoordinateDataResponse.displayName = 'proto.api.GetTripCoordinateDataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.GetTripCoordinateDataResponse.TripCoordinateItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.displayName = 'proto.api.GetTripCoordinateDataResponse.TripCoordinateItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetVehiclesTripsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.GetVehiclesTripsRequest.repeatedFields_, null);
};
goog.inherits(proto.api.GetVehiclesTripsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetVehiclesTripsRequest.displayName = 'proto.api.GetVehiclesTripsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetVehiclesTripsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.GetVehiclesTripsResponse.repeatedFields_, null);
};
goog.inherits(proto.api.GetVehiclesTripsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetVehiclesTripsResponse.displayName = 'proto.api.GetVehiclesTripsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.GetVehiclesTripsResponse.VehicleTripItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetVehiclesTripsResponse.VehicleTripItem.displayName = 'proto.api.GetVehiclesTripsResponse.VehicleTripItem';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetTripCoordinateDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetTripCoordinateDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetTripCoordinateDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetTripCoordinateDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tripId: jspb.Message.getFieldWithDefault(msg, 1, 0),
from: jspb.Message.getFieldWithDefault(msg, 2, ""),
to: jspb.Message.getFieldWithDefault(msg, 3, ""),
vehicleDeviceId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetTripCoordinateDataRequest}
 */
proto.api.GetTripCoordinateDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetTripCoordinateDataRequest;
  return proto.api.GetTripCoordinateDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetTripCoordinateDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetTripCoordinateDataRequest}
 */
proto.api.GetTripCoordinateDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTripId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleDeviceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetTripCoordinateDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetTripCoordinateDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetTripCoordinateDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetTripCoordinateDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTripId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVehicleDeviceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 trip_id = 1;
 * @return {number}
 */
proto.api.GetTripCoordinateDataRequest.prototype.getTripId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetTripCoordinateDataRequest} returns this
 */
proto.api.GetTripCoordinateDataRequest.prototype.setTripId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string from = 2;
 * @return {string}
 */
proto.api.GetTripCoordinateDataRequest.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetTripCoordinateDataRequest} returns this
 */
proto.api.GetTripCoordinateDataRequest.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string to = 3;
 * @return {string}
 */
proto.api.GetTripCoordinateDataRequest.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetTripCoordinateDataRequest} returns this
 */
proto.api.GetTripCoordinateDataRequest.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string vehicle_device_id = 4;
 * @return {string}
 */
proto.api.GetTripCoordinateDataRequest.prototype.getVehicleDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetTripCoordinateDataRequest} returns this
 */
proto.api.GetTripCoordinateDataRequest.prototype.setVehicleDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.api.GetTripCoordinateDataResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetTripCoordinateDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetTripCoordinateDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetTripCoordinateDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetTripCoordinateDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
coordinatesList: jspb.Message.toObjectList(msg.getCoordinatesList(),
    proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetTripCoordinateDataResponse}
 */
proto.api.GetTripCoordinateDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetTripCoordinateDataResponse;
  return proto.api.GetTripCoordinateDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetTripCoordinateDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetTripCoordinateDataResponse}
 */
proto.api.GetTripCoordinateDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.api.GetTripCoordinateDataResponse.TripCoordinateItem;
      reader.readMessage(value,proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.deserializeBinaryFromReader);
      msg.addCoordinates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetTripCoordinateDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetTripCoordinateDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetTripCoordinateDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetTripCoordinateDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCoordinatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.toObject = function(includeInstance, msg) {
  var f, obj = {
lat: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
lng: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem}
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetTripCoordinateDataResponse.TripCoordinateItem;
  return proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem}
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLng(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLng();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double lat = 1;
 * @return {number}
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.prototype.getLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem} returns this
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.prototype.setLat = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double lng = 2;
 * @return {number}
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.prototype.getLng = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem} returns this
 */
proto.api.GetTripCoordinateDataResponse.TripCoordinateItem.prototype.setLng = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * repeated TripCoordinateItem coordinates = 1;
 * @return {!Array<!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem>}
 */
proto.api.GetTripCoordinateDataResponse.prototype.getCoordinatesList = function() {
  return /** @type{!Array<!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.api.GetTripCoordinateDataResponse.TripCoordinateItem, 1));
};


/**
 * @param {!Array<!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem>} value
 * @return {!proto.api.GetTripCoordinateDataResponse} returns this
*/
proto.api.GetTripCoordinateDataResponse.prototype.setCoordinatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.GetTripCoordinateDataResponse.TripCoordinateItem}
 */
proto.api.GetTripCoordinateDataResponse.prototype.addCoordinates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.api.GetTripCoordinateDataResponse.TripCoordinateItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.GetTripCoordinateDataResponse} returns this
 */
proto.api.GetTripCoordinateDataResponse.prototype.clearCoordinatesList = function() {
  return this.setCoordinatesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.api.GetVehiclesTripsRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetVehiclesTripsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetVehiclesTripsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetVehiclesTripsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehiclesTripsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && page_pb.PageRequest.toObject(includeInstance, f),
startDate: jspb.Message.getFieldWithDefault(msg, 1, 0),
endDate: jspb.Message.getFieldWithDefault(msg, 2, 0),
clientIdList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
searchString: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetVehiclesTripsRequest}
 */
proto.api.GetVehiclesTripsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetVehiclesTripsRequest;
  return proto.api.GetVehiclesTripsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetVehiclesTripsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetVehiclesTripsRequest}
 */
proto.api.GetVehiclesTripsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new page_pb.PageRequest;
      reader.readMessage(value,page_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addClientId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchString(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetVehiclesTripsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetVehiclesTripsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetVehiclesTripsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehiclesTripsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      page_pb.PageRequest.serializeBinaryToWriter
    );
  }
  f = message.getStartDate();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndDate();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getClientIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getSearchString();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional PageRequest page = 3;
 * @return {?proto.api.PageRequest}
 */
proto.api.GetVehiclesTripsRequest.prototype.getPage = function() {
  return /** @type{?proto.api.PageRequest} */ (
    jspb.Message.getWrapperField(this, page_pb.PageRequest, 3));
};


/**
 * @param {?proto.api.PageRequest|undefined} value
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
*/
proto.api.GetVehiclesTripsRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
 */
proto.api.GetVehiclesTripsRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.api.GetVehiclesTripsRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 start_date = 1;
 * @return {number}
 */
proto.api.GetVehiclesTripsRequest.prototype.getStartDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
 */
proto.api.GetVehiclesTripsRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end_date = 2;
 * @return {number}
 */
proto.api.GetVehiclesTripsRequest.prototype.getEndDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
 */
proto.api.GetVehiclesTripsRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string client_id = 4;
 * @return {!Array<string>}
 */
proto.api.GetVehiclesTripsRequest.prototype.getClientIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
 */
proto.api.GetVehiclesTripsRequest.prototype.setClientIdList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
 */
proto.api.GetVehiclesTripsRequest.prototype.addClientId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
 */
proto.api.GetVehiclesTripsRequest.prototype.clearClientIdList = function() {
  return this.setClientIdList([]);
};


/**
 * optional string search_string = 5;
 * @return {string}
 */
proto.api.GetVehiclesTripsRequest.prototype.getSearchString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehiclesTripsRequest} returns this
 */
proto.api.GetVehiclesTripsRequest.prototype.setSearchString = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.api.GetVehiclesTripsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetVehiclesTripsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetVehiclesTripsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetVehiclesTripsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehiclesTripsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && page_pb.PageResponse.toObject(includeInstance, f),
tripsList: jspb.Message.toObjectList(msg.getTripsList(),
    proto.api.GetVehiclesTripsResponse.VehicleTripItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetVehiclesTripsResponse}
 */
proto.api.GetVehiclesTripsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetVehiclesTripsResponse;
  return proto.api.GetVehiclesTripsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetVehiclesTripsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetVehiclesTripsResponse}
 */
proto.api.GetVehiclesTripsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new page_pb.PageResponse;
      reader.readMessage(value,page_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 2:
      var value = new proto.api.GetVehiclesTripsResponse.VehicleTripItem;
      reader.readMessage(value,proto.api.GetVehiclesTripsResponse.VehicleTripItem.deserializeBinaryFromReader);
      msg.addTrips(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetVehiclesTripsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetVehiclesTripsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetVehiclesTripsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehiclesTripsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      page_pb.PageResponse.serializeBinaryToWriter
    );
  }
  f = message.getTripsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.api.GetVehiclesTripsResponse.VehicleTripItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetVehiclesTripsResponse.VehicleTripItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.toObject = function(includeInstance, msg) {
  var f, obj = {
riderName: jspb.Message.getFieldWithDefault(msg, 1, ""),
startTime: jspb.Message.getFieldWithDefault(msg, 2, ""),
endTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
totalKm: jspb.Message.getFieldWithDefault(msg, 4, 0),
score: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
socUsed: jspb.Message.getFieldWithDefault(msg, 6, ""),
licensePlate: jspb.Message.getFieldWithDefault(msg, 7, ""),
id: jspb.Message.getFieldWithDefault(msg, 8, ""),
totalBattery: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetVehiclesTripsResponse.VehicleTripItem;
  return proto.api.GetVehiclesTripsResponse.VehicleTripItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiderName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalKm(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScore(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSocUsed(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLicensePlate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalBattery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetVehiclesTripsResponse.VehicleTripItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiderName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartTime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEndTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalKm();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getSocUsed();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLicensePlate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTotalBattery();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional string rider_name = 1;
 * @return {string}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getRiderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setRiderName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string start_time = 2;
 * @return {string}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setStartTime = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string end_time = 3;
 * @return {string}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setEndTime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 total_km = 4;
 * @return {number}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getTotalKm = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setTotalKm = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional float score = 5;
 * @return {number}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string soc_used = 6;
 * @return {string}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getSocUsed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setSocUsed = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string license_plate = 7;
 * @return {string}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getLicensePlate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setLicensePlate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string id = 8;
 * @return {string}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 total_battery = 9;
 * @return {number}
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.getTotalBattery = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem} returns this
 */
proto.api.GetVehiclesTripsResponse.VehicleTripItem.prototype.setTotalBattery = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional PageResponse page = 1;
 * @return {?proto.api.PageResponse}
 */
proto.api.GetVehiclesTripsResponse.prototype.getPage = function() {
  return /** @type{?proto.api.PageResponse} */ (
    jspb.Message.getWrapperField(this, page_pb.PageResponse, 1));
};


/**
 * @param {?proto.api.PageResponse|undefined} value
 * @return {!proto.api.GetVehiclesTripsResponse} returns this
*/
proto.api.GetVehiclesTripsResponse.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.api.GetVehiclesTripsResponse} returns this
 */
proto.api.GetVehiclesTripsResponse.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.api.GetVehiclesTripsResponse.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated VehicleTripItem trips = 2;
 * @return {!Array<!proto.api.GetVehiclesTripsResponse.VehicleTripItem>}
 */
proto.api.GetVehiclesTripsResponse.prototype.getTripsList = function() {
  return /** @type{!Array<!proto.api.GetVehiclesTripsResponse.VehicleTripItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.api.GetVehiclesTripsResponse.VehicleTripItem, 2));
};


/**
 * @param {!Array<!proto.api.GetVehiclesTripsResponse.VehicleTripItem>} value
 * @return {!proto.api.GetVehiclesTripsResponse} returns this
*/
proto.api.GetVehiclesTripsResponse.prototype.setTripsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.api.GetVehiclesTripsResponse.VehicleTripItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.GetVehiclesTripsResponse.VehicleTripItem}
 */
proto.api.GetVehiclesTripsResponse.prototype.addTrips = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.api.GetVehiclesTripsResponse.VehicleTripItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.GetVehiclesTripsResponse} returns this
 */
proto.api.GetVehiclesTripsResponse.prototype.clearTripsList = function() {
  return this.setTripsList([]);
};


goog.object.extend(exports, proto.api);
